// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.serviceList[data-v-746a8d7d] {\n  display: flex;\n  width: 100%;\n  max-width: 560px;\n\n  gap: 20px;\n  align-items: center;\n  /* padding: 15px 0; */\n  flex-wrap: wrap;\n\n  justify-content: center;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
